import FileUploadedItemV2 from 'components/molecules/FileUploadedList/FileUploadedItemV2.component';
import { useCallback, type FC } from 'react';
import { useAIChatContext } from './AIChat.context';

const AIChatAttachements: FC = () => {
  const { attachmentApi } = useAIChatContext();
  const { attachment, upload, remove } = attachmentApi;

  const handleRetry = useCallback(() => {
    if (!attachment?.file) return;
    upload(attachment.file);
  }, [attachment, upload]);

  if (!attachment) return null;

  return (
    <div className="w-full flex items-center mt-1">
      <FileUploadedItemV2
        name={attachment.file.name}
        size={attachment.file.size}
        status={attachment.status}
        progress={attachment.progress || 0}
        onRetry={handleRetry}
        onRemove={remove}
      />
    </div>
  );
};
export default AIChatAttachements;
